export default "__VITE_PUBLIC_ASSET__3ce0770b__"